import { filter, orderBy } from 'lodash';
import { checkFilterMatch } from '../../../../../utils/filters';

export function applyFilter(headCols, files, filters, sortBy, sortOrders, isPartner) {
  let filteredFiles = [];
  let isFiltered = false;

  // Filter data
  if (filters.resource) {
    filteredFiles = filteredFiles.concat(filter(files, (file) => checkFolderOwner(file.path, 'resource')));
    isFiltered = true;
  }

  if (filters.client) {
    filteredFiles = filteredFiles.concat(filter(files, (file) => checkFolderOwner(file.path, 'client')));
    isFiltered = true;
  }

  if (filters.company) {
    filteredFiles = filteredFiles.concat(filter(files, (file) => checkFolderOwner(file.path, 'company')));
    isFiltered = true;
  }

  if (isPartner && filters.partnerDemand) {
    filteredFiles = filteredFiles.concat(filter(files, (file) => file.path.includes('demandes_partenaires')));
    isFiltered = true;
  }

  if (filters.search) {
    filteredFiles = filter(filteredFiles, (file) => {
      for (let idx = 0; idx < headCols.length; idx += 1) {
        if (checkFilterMatch(headCols, idx, file, filters)) {
          return true;
        }
      }
      return false;
    });
    isFiltered = true;
  }

  if (!isFiltered) {
    filteredFiles = files;
  }

  // Sort data
  filteredFiles = orderBy(filteredFiles, sortBy, sortOrders);
  return filteredFiles;
}

export function fileRewriteUrl(item) {
  if (!item.url) {
    return '';
  }

  if (['docx', 'file', 'ppsx', 'ppt', 'pptx', 'rtf', 'xls', 'xlsx', 'xlsxm'].includes(item.extension)) {
    const src = encodeURIComponent(item.url);
    return `https://view.officeapps.live.com/op/embed.aspx?src=${src}`;
  }

  return item.url;
}

function checkFolderOwner(filePath, targetType) {
  // Extract the segment after "\\fichiers\\"
  const match = filePath.match(/(?:^|\\)fichiers\\(.).*\\/);

  // Partners's documents don't have \\fichiers\\ in theirs paths
  if (!match) {
    return false;
  }

  // Check if a match was found
  if (match && match[1]) {
    const charAfterFichiers = match[1];

    // Check if the character is a number or a letter
    if (/\d/.test(charAfterFichiers)) {
      // The character is a number
      return targetType === 'resource';
    }
    if (/[a-zA-Z]/.test(charAfterFichiers)) {
      // The character is a letter
      switch (charAfterFichiers) {
        case 'C':
          return targetType === 'client';
        case 'S':
          return targetType === 'company';
        default:
          return false;
      }
    } else {
      console.error('The character is neither a number nor a letter:', charAfterFichiers);
    }
  }
  console.error("No character found after '\\fichiers\\'.");
}
